import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_469: DocMigration = {
  maxSchemaVersion: "0.0.469",
  description: "Remove eyeLevel from CameraPosition",
  apply(json: any) {
    const { elevations } = json;

    const elevationIds = Object.keys(elevations);
    for (const elevationId of elevationIds) {
      const elevation = elevations[elevationId];
      if (elevation.defaultExteriorCamera) {
        delete elevation.defaultExteriorCamera.eyeLevel;
      }
      if (elevation.topLeftPerspectiveCamera) {
        delete elevation.topLeftPerspectiveCamera.eyeLevel;
      }
      if (elevation.topRightPerspectiveCamera) {
        delete elevation.topRightPerspectiveCamera.eyeLevel;
      }
      if (elevation.bottomLeftPerspectiveCamera) {
        delete elevation.bottomLeftPerspectiveCamera.eyeLevel;
      }
      if (elevation.bottomRightPerspectiveCamera) {
        delete elevation.bottomRightPerspectiveCamera.eyeLevel;
      }
    }
    return json;
  },
};

export default migration_0_0_469;
